<!-- <app-asset-map [installs]="installs"></app-asset-map> -->
<div id="map"></div>
<div mat-dialog-actions>
    <!-- <button mat-button color="warn" (click)="onNoClick()">No</button> -->
    <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Okay</button>
</div>